var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 26,
    width: 26,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    className: "text-samurai-gray-300 dark:text-samurai-gray-100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.042 14.417q.541 0 .958-.417.417-.417.417-.958 0-.584-.417-1-.417-.417-.958-.417-.584 0-1 .417-.417.416-.417 1 0 .541.417.958.416.417 1 .417Zm0 6.958q.541 0 .958-.396.417-.396.417-.979T14 19.021q-.417-.396-.958-.396-.584 0-1 .396-.417.396-.417.979t.417.979q.416.396 1 .396Zm0 7q.541 0 .958-.417.417-.416.417-1 0-.541-.417-.958-.417-.417-.958-.417-.584 0-1 .417-.417.417-.417.958 0 .584.417 1 .416.417 1 .417ZM7.792 35q-1.125 0-1.959-.833Q5 33.333 5 32.208V7.792q0-1.125.833-1.959Q6.667 5 7.792 5h18.916L35 13.292v18.916q0 1.125-.833 1.959-.834.833-1.959.833Zm0-2.792h24.416V14.75H25.25V7.792H7.792v24.416Zm0-24.416v6.958-6.958V32.208 7.792Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.b7adf11c8639bb4d862db9cbf07668de.svg";
export { ForwardRef as ReactComponent };